import React from 'react';
import App from 'next/app';
import Script from 'next/script';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { SWRConfig, useSWRConfig } from 'swr';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-vis/dist/style.css';
import 'leaflet/dist/leaflet.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import EmotionCacheProvider from '../components/EmotionCacheProvider';
import Provider from '../contexts/authContext';
import myTheme from '../components/theme';
import notoSansTC from '../styles/fonts';
import { fetcher } from '../utils/axios';
import '../public/nprogress.css';

config.autoAddCss = false;
const theme = extendTheme(myTheme);

const initializeGoogleAnalytics = () => {
	window.dataLayer = window.dataLayer || [];
	window.gtag = function gtag(...args) {
		window.dataLayer.push(args);
	};
	window.gtag('js', new Date());
	window.gtag('config', 'G-MFKYR264F3');
};

function MyApp({ Component, pageProps, emotionCache }) {
	const { cache } = useSWRConfig();
	return (
		<EmotionCacheProvider cache={emotionCache}>
			<div className={notoSansTC.variable}>
				<Provider>
					<ChakraProvider theme={theme}>
						<SWRConfig
							value={{
							fetcher,
							onError: (e) => {
								switch (e?.response?.status) {
								case 401:
								// case 404:
									cache.clear();
									break;
								default:
									}
								},
						}}
						>
							<Script
								strategy="afterInteractive"
								src="https://www.googletagmanager.com/gtag/js?id=G-MFKYR264F3"
								onLoad={initializeGoogleAnalytics}
							/>
							<Component {...pageProps} />
						</SWRConfig>
					</ChakraProvider>
				</Provider>
			</div>
		</EmotionCacheProvider>
	);
}

// Nonces are unique per HTML response, so even pages without data fetching must
// render on demand rather than reuse build-time HTML.
MyApp.getInitialProps = async (appContext) => App.getInitialProps(appContext);

export default MyApp;
